import { EditDealType } from 'models/deals.model';
import moment from 'moment';

export const getPayload = (
  editDealForm: EditDealType,
  isDetailsPage: boolean,
  isSettingsPage: boolean,
  isTimelinePage: boolean
) => {
  let payload = {};

  if (isDetailsPage) {
    payload = {
      heading: editDealForm.heading,
      title: editDealForm.title,
      body: editDealForm.body,
      images: editDealForm.images,
      cokitchen_id: editDealForm.cokitchen_id
    };
  } else if (isSettingsPage) {
    payload = {
      private: editDealForm.private,
      discount_code: editDealForm.discount_code,
      deal_value_type_id: editDealForm.deal_value_type_id,
      rate: editDealForm.rate || '0',
      fixed_amount: editDealForm.fixed_amount || '0',
      cap: editDealForm.cap ? Number(editDealForm.cap) : 0,
      max_usage: editDealForm.max_usage,
      deal_type_id: editDealForm.deal_type_id,
      brands: editDealForm.brands,
      deal_requirement_type_id: editDealForm.deal_requirement_type_id,
      min_amount: editDealForm.min_amount || '0',
      min_items: editDealForm.min_items || '0',
      deal_eligibility_type_id: editDealForm.deal_eligibility_type_id,
      specific_customers: editDealForm.specific_customers,
      active: editDealForm.active
    };
  } else if (isTimelinePage) {
    payload = {
      to_start_date: moment(editDealForm.to_start_date).format('YYYY-MM-DD'),
      to_start_time: `${editDealForm?.to_start_time?.timeWithColon}:00`,
      ...(editDealForm.to_expire_date && {
        to_expire_date: moment(editDealForm.to_expire_date).format('YYYY-MM-DD')
      }),
      ...(editDealForm?.to_expire_time?.timeWithColon && {
        to_expire_time: `${editDealForm?.to_expire_time?.timeWithColon}:00`
      })
    };
  }

  return payload;
};
